module.exports = __webpack_public_path__ + "img/shouan2x.937898b5.png";